import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
const Step3ConfigStateDefault = {
    fileData: null,
    mappingValues: null,
    updateFileData: null
};
export const CorpDataInterchangeStep3Context = createContext(Step3ConfigStateDefault);
function CorpDataInterchangeConfigStep3Provider({ data, mappingValues, updateFileData, children }) {
    const value = useMemo(() => ({ fileData: data, mappingValues, updateFileData }), [data, mappingValues, updateFileData]);
    return (_jsx(CorpDataInterchangeStep3Context.Provider, { value: value, children: children }));
}
export default CorpDataInterchangeConfigStep3Provider;
